<div id="print-section">
  @for (page of pages; track page) {
    <section class="page">
      <div class="label-container">
        <div class="title-container">
          <h1 class="transaction-id">{{ page.transactionId }}</h1>
          <h1 class="customer-name">{{ page.customer }}</h1>
        </div>
        <h2>{{ page.description }}</h2>
        <div class="details-container">
          <div>
            @if (page.numberOfVersions) {
              <p>{{ 'numberOfVersions' | translate }} : {{ page.numberOfVersions }}</p>
            }
          </div>
        </div>
      </div>
    </section>
  }
</div>
